<template>
    <div>
      <LoadingMessage
        :isActive="loading"
        message="Carregando logotipos"
        :alignCenter="true"
      />
      <div class="xrow" v-for="logo in logos">
        <CAlert color="info">
          {{ logo.secao_descricao }}
        </CAlert>
        <template v-for="(secao, index) in logo.secoes">
          <h2>{{ secao.secao_titulo }}</h2>
          <table class="table table-hover">
            <tbody>
            <LinhaLogotipo
              v-for="logo in secao.imagens"
              :image-url="`${logo.url}?cache=${hash}`"
              :title="logo.titulo"
              :text="logo.descricao"
              :upload="() => upload(logo.tipo, logo.schema)"
              :custom="logo.customizado"
              :deleteLogo="() => deleteLogo(logo.tipo, logo.schema)"
            />
            </tbody>
          </table>
        </template>
      </div>
    </div>
</template>
<script>
import CardImage from "@/views/Logos/Backgrounds/CardImage.vue";
import LinhaLogotipo from "@/views/Logos/Logotipos/LinhaLogotipo.vue";

export default {
  name: 'logos',
  components: {LinhaLogotipo, CardImage},
  props: [
    'logos',
    'upload',
    'deleteLogo',
    'logoUrl',
    'faviconUrl',
    'hash',
    'loading'
  ],
};
</script>
